<div class="bg-white rounded p-2">
  <app-assets-list
    [assetColumns]="assetColumns"
    [(selected)]="selected"
    [list]="list"
    [hideCheckbox]="true"
    [isBusy]="isBusy"
    [assetIdForSubAssets]="asset.id"
  ></app-assets-list>
</div>
